module.exports = __webpack_public_path__ + "img/Blueberries.bb5480d0.png";